import { KEY_PREFIX } from "../constant";
var StorageBlueprint = /** @class */ (function () {
    function StorageBlueprint(writeKey) {
        this.writeKey = writeKey;
    }
    StorageBlueprint.prototype.getKey = function (key) {
        return "".concat(KEY_PREFIX, "_").concat(this.writeKey, ".").concat(key);
    };
    return StorageBlueprint;
}());
export default StorageBlueprint;
//# sourceMappingURL=blueprint.js.map